module.exports = __webpack_public_path__ + "static/media/TallinkSiljaLogo.2edbeac8.svg";